import { config } from '#~/config/index.js';
import { memoize } from 'lodash-es';

// cache for each role
const electronFlags: Record<'any' | 'interface' | 'worker' | 'tray', boolean> = {
  any: false,
  interface: false,
  worker: false,
  tray: false
};

// check if environment is available
const isElectronEnv = window.electron?.process?.env !== undefined;

if (isElectronEnv) {
  const url = new URL(window.location.href);
  let currentRole = url.searchParams.get('iris_role') ?? 'interface';
  currentRole = currentRole.split('?')[0] ?? '';
  currentRole = currentRole.split('#')[0] ?? '';
  currentRole = currentRole.split('/')[0] ?? '';
  currentRole = currentRole.split('.')[0] ?? '';
  currentRole = currentRole.split('=')[0] ?? '';
  currentRole = currentRole.split('&')[0] ?? '';

  // Cache the flags:
  // If we're running in Electron, the 'any' flag is true.
  electronFlags.any = true;
  electronFlags.interface = currentRole === 'interface';
  electronFlags.worker = currentRole === 'worker' || currentRole === 'interface';
  electronFlags.tray = currentRole === 'tray';
}

export const isElectronApp = (role: 'interface' | 'worker' | 'tray' | 'any' = 'any'): boolean => {
  return electronFlags[role];
};

export const authoriseCode = memoize(
  ({ code, url }: { code: string; url: string }) => {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ code })
    }).then((v) => v.json());
  },
  ({ code, url }) => code + url
);

export const getElectronUrl = (path: string) => {
  let protocol = config.vendor === 'ptzoptics' ? 'hive' : 'iris';

  const url = new URL(window.location.href);

  // Check if the last path segment is either "itg" or "stg"
  const pathSegments = url.pathname.split('/');
  const lastSegment = pathSegments[pathSegments.length - 1];
  const matches = ['itg', 'stg'];

  if (matches.includes(lastSegment ?? '')) {
    protocol = `${protocol}-${lastSegment}`;
  }

  return `${protocol}://${path}`;
};
